import { DefaultItem } from '@adsk/alloy-react-dropdown';

export type ItemWithImage = DefaultItem & { imageUrl?: string };

export const IconSize = 24;

export const PROJECT_TYPES_DATA: DefaultItem[] = [
  {
    value: 'bim360',
    label: 'BIM360',
  },
  {
    value: 'acc',
    label: 'ACC',
  },
];
